export const SlicesName = {
  Users: "users",
};

export const ReducersName = {
  Users: "users",
};
